/**
 * Auto Send Detection Hook
 *
 * Detects when the user says "send" or "submit" in their transcription
 * and automatically triggers message submission.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
type AutoSendDetectionOptions = {
  enabled: boolean;
  transcript: string;
  onSendDetected: () => void;
  // Words that trigger auto-send
  triggerWords?: string[];
};
export function useAutoSendDetection(options) {
  const $ = _c(8);
  const {
    enabled,
    transcript,
    onSendDetected,
    triggerWords: t0
  } = options;
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? ["send", "submit", "send it", "submit it"] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const triggerWords = t1;
  const lastTranscriptRef = useRef("");
  let t2;
  let t3;
  if ($[2] !== enabled || $[3] !== onSendDetected || $[4] !== transcript || $[5] !== triggerWords) {
    t2 = () => {
      if (!enabled || !transcript) {
        return;
      }
      if (transcript === lastTranscriptRef.current) {
        return;
      }
      lastTranscriptRef.current = transcript;
      const normalizedTranscript = transcript.toLowerCase().trim();
      const endsWithTrigger = triggerWords.some(word => {
        const normalizedWord = word.toLowerCase();
        if (normalizedTranscript.endsWith(normalizedWord)) {
          return true;
        }
        if (normalizedTranscript.endsWith(`${normalizedWord}.`) || normalizedTranscript.endsWith(`${normalizedWord}!`) || normalizedTranscript.endsWith(`${normalizedWord}?`)) {
          return true;
        }
        return false;
      });
      if (endsWithTrigger) {
        console.log("[Auto Send] Trigger word detected in transcript:", transcript);
        onSendDetected();
      }
    };
    t3 = [enabled, transcript, triggerWords, onSendDetected];
    $[2] = enabled;
    $[3] = onSendDetected;
    $[4] = transcript;
    $[5] = triggerWords;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
}